import { render } from "./editBtns.vue?vue&type=template&id=4b90a718"
import script from "./editBtns.vue?vue&type=script&lang=js"
export * from "./editBtns.vue?vue&type=script&lang=js"

import "./editBtns.vue?vue&type=style&index=0&id=4b90a718&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__